import {
  type Alignment,
  type Placement,
  autoPlacement,
  computePosition,
  inline,
} from "@floating-ui/dom";
import { Controller } from "@hotwired/stimulus";

export default class TipableController extends Controller {
  static targets = ["tooltip"];
  static values = {
    alignment: String,
    placements: {
      default: [""],
      type: Array,
    },
  };
  declare alignmentValue: Alignment;
  declare readonly hasAlignmentValue: boolean;

  declare hasPlacementsValue: boolean;

  declare readonly hasTextValue: boolean;
  declare readonly hasTooltipTarget: boolean;
  declare placementsValue: Placement[];
  declare textValue: string;
  declare readonly tooltipTarget: HTMLElement;
  declare readonly tooltipTargets: HTMLElement[];

  private async computeTooltip(
    clientX: number,
    clientY: number,
  ): Promise<void> {
    if (!this.hasTooltipTarget) return;

    await computePosition(this.element, this.tooltipTarget, {
      middleware: [
        inline({
          x: clientX,
          y: clientY,
        }),
        autoPlacement({
          alignment: this.hasAlignmentValue ? this.alignmentValue : undefined,
          allowedPlacements: this.hasPlacementsValue
            ? this.placementsValue
            : undefined,
        }),
      ],
    }).then(({ x, y }) => {
      Object.assign(this.tooltipTarget.style, {
        left: `${x}px`,
        top: `${y}px`,
      });
    });
  }

  async hide({ clientX, clientY }: MouseEvent): Promise<void> {
    await this.computeTooltip(clientX, clientY);
    this.tooltipTarget.classList.add("hidden");
    this.tooltipTarget.classList.remove("block");
  }

  async show({ clientX, clientY }: MouseEvent): Promise<void> {
    await this.computeTooltip(clientX, clientY);
    this.tooltipTarget.classList.add("block");
    this.tooltipTarget.classList.remove("hidden");
  }
}
